module.exports = __webpack_public_path__ + "static/media/dal-logo.159f2b2f.png";